export default {
  collections: 'Collezioni',
  systems: 'Sistemi',
  filters: 'Filtra per',
  'alt-complementary-text': 'Immagine relativa al prodotto',
}
